export default function setupJQuery() {
    const JQuery = require('jquery')
    window.$ = JQuery
    window.JQuery = JQuery
}
